import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';
import { MergeDataset } from '../../decorators/decorators/merge.dataset';
import { InvoiceMergeDataset } from './invoice.merge.dataset';

@MergeDataset({
    entity: ActivityEntityName.CreditNote,
    dependsOn: [
        ActivityEntityName.Job
    ]
})
export class CreditNoteMergeDataset extends InvoiceMergeDataset {
}


